<button class="btn btn-lg btn-flat">
  <em class="icon">task_alt</em>
</button>
